/**
 * @generated SignedSource<<0325665c7149d70e77020147ef5a0732>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accessGate_MeQuery$variables = Record<PropertyKey, never>;
export type accessGate_MeQuery$data = {
  readonly me: {
    readonly accessGrantedAt: string | null | undefined;
    readonly dataRevealedAt: string | null | undefined;
    readonly impersonated: boolean;
  } | null | undefined;
};
export type accessGate_MeQuery = {
  response: accessGate_MeQuery$data;
  variables: accessGate_MeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessGrantedAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataRevealedAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "impersonated",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accessGate_MeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accessGate_MeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95de40dde9c7b8dce5eea789b6935991",
    "id": null,
    "metadata": {},
    "name": "accessGate_MeQuery",
    "operationKind": "query",
    "text": "query accessGate_MeQuery {\n  me {\n    accessGrantedAt\n    dataRevealedAt\n    impersonated\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e844c95e894aff02a3ae21192d1a9f4";

export default node;
